import React from 'react';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { DetailsCard, useThemedValueSwitch } from '@tq/ui-components';

import {
  ConsultationCardBody,
  ConsultationCardFooter,
  ConsultationCardHeader,
} from './components';
import { ConsultationCardProps } from './types';
import { useNavigate } from '../../hooks';

export const ConsultationCard: React.FC<ConsultationCardProps> = ({
  consultation,
  isHighlighted,
}) => {
  const { navigateToSummary } = useNavigate();
  const { tvs } = useThemedValueSwitch();
  const defaultCardStyles = tvs({
    tq: {
      border: '1px solid',
      borderColor: 'grey.300',
      background: 'white',
    },
    ni: {
      border: '1px solid',
      borderColor: COLOURS.gray[200],
      background: 'unset',
    },
  });
  const highlightedCardStyles = tvs({
    tq: {
      border: '2px solid',
      borderColor: 'green.500',
      background: 'green.900',
    },
    ni: {
      border: '2px solid',
      borderColor: COLOURS.green[500],
      background: COLOURS.neutral[11],
    },
  });

  return (
    <DetailsCard
      as='li'
      height='max-content'
      data-testid='consultation-card'
      cursor='pointer'
      borderRadius={tvs({ tq: '.187rem', ni: '.312rem' })}
      onClick={() => navigateToSummary(consultation.id)}
      sx={isHighlighted ? highlightedCardStyles : defaultCardStyles}
    >
      <ConsultationCardHeader consultation={consultation} />
      <ConsultationCardBody consultation={consultation} />
      <ConsultationCardFooter consultation={consultation} isHighlighted={isHighlighted} />
    </DetailsCard>
  );
};
